module.exports = __webpack_public_path__ + "static/logo-3f01e287d927ec169edd7f338a6bee22.png";